import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { Action, combineReducers, createFeatureSelector, createSelector, provideState } from '@ngrx/store';
import { PreferencesEffects } from '../effects/preferences.effects';
import { ProfileEffects } from '../effects/profile.effects';
import * as fromUserPreferencesDb from './preferences-db.reducer';
import * as fromUserPreferencesUi from './preferences-ui.reducer';
import * as fromUserProfileDb from './profile-db.reducer';
import * as fromUserProfileUi from './profile-ui.reducer';

// user preferences
export const userPreferencesFeatureKey = 'userPreferences';

export interface UserPreferencesState {
  [fromUserPreferencesDb.userPreferencesDbFeatureKey]: fromUserPreferencesDb.State;
  [fromUserPreferencesUi.userPreferencesUiFeatureKey]: fromUserPreferencesUi.State;
}

export function userPreferencesReducers(state: UserPreferencesState | undefined, action: Action) {
  return combineReducers({
    [fromUserPreferencesDb.userPreferencesDbFeatureKey]: fromUserPreferencesDb.reducer,
    [fromUserPreferencesUi.userPreferencesUiFeatureKey]: fromUserPreferencesUi.reducer
  })(state, action);
}

export const selectUserPreferencesState = createFeatureSelector<UserPreferencesState>(userPreferencesFeatureKey);

export const selectUserPreferencesDbState = createSelector(
  selectUserPreferencesState,
  (state: UserPreferencesState) => state[fromUserPreferencesDb.userPreferencesDbFeatureKey]
);

export const selectUserPreferencesUiState = createSelector(
  selectUserPreferencesState,
  (state: UserPreferencesState) => state[fromUserPreferencesUi.userPreferencesUiFeatureKey]
);

export const getCurrentPreferencesUser = createSelector(selectUserPreferencesDbState, fromUserPreferencesDb.getCurrentUser);
export const getPreferences = createSelector(selectUserPreferencesDbState, fromUserPreferencesDb.getPreferences);

export const getUserPreferencesError = createSelector(selectUserPreferencesUiState, fromUserPreferencesUi.getError);

export const getUserPreferencesLoading = createSelector(selectUserPreferencesUiState, fromUserPreferencesUi.getLoading);

// user profile
export const userProfileFeatureKey = 'userProfile';

export interface UserProfileState {
  [fromUserProfileDb.userProfileDbFeatureKey]: fromUserProfileDb.State;
  [fromUserProfileUi.userProfileUiFeatureKey]: fromUserProfileUi.State;
}

export function userProfileReducers(state: UserProfileState | undefined, action: Action) {
  return combineReducers({
    [fromUserProfileDb.userProfileDbFeatureKey]: fromUserProfileDb.reducer,
    [fromUserProfileUi.userProfileUiFeatureKey]: fromUserProfileUi.reducer
  })(state, action);
}

export const selectUserProfileState = createFeatureSelector<UserProfileState>(userProfileFeatureKey);

export const selectUserProfileDbState = createSelector(selectUserProfileState, (state: UserProfileState) => state[fromUserProfileDb.userProfileDbFeatureKey]);

export const selectUserProfileUiState = createSelector(selectUserProfileState, (state: UserProfileState) => state[fromUserProfileUi.userProfileUiFeatureKey]);

export const getCurrentProfileUser = createSelector(selectUserProfileDbState, fromUserProfileDb.getCurrentUser);

export const getUserProfileError = createSelector(selectUserProfileUiState, fromUserProfileUi.getError);

export const getUserProfileLoading = createSelector(selectUserProfileUiState, fromUserProfileUi.getLoading);
